import { FC } from 'react';
import { LocationsFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterTraySection } from '../filter-tray-section/filter-tray-section';
import { useLocationFilterData } from './use-location-filter-data';

interface LocationFilterTrayProps {
  disabled?: boolean;
  trackingId?: string;
  sectionLabel?: string;
}

export const LocationFilterTray: FC<LocationFilterTrayProps> = ({ disabled, trackingId, sectionLabel }) => {
  const { t } = useTranslation('call-intelligence');
  const { isLoading, isMultiLocation, locations, selectedLocations, updateErrors, onChange } = useLocationFilterData();

  if (!isMultiLocation) {
    return null;
  }

  return (
    <FilterTraySection label={sectionLabel || t('Location')} showClear={false}>
      <LocationsFilterSelector
        disabled={disabled || isLoading}
        locations={locations}
        onChange={onChange}
        onError={(error) => updateErrors({ locations: error.value })}
        trackingId={trackingId || trackingIds.callIntel.locationsSelector}
        value={selectedLocations}
      />
    </FilterTraySection>
  );
};
